export default __webpack_public_path__ + "static/media/about.4d00542b.jpg";